import { useCurrentUser as useCurrentUser_ } from 'solid-compose';
export default function useCurrentUser() {
    return useCurrentUser_();
}
